import React, { useEffect, useState } from 'react';
import { get, ref } from 'firebase/database';
import { database } from '../firebaseConfig';

// Shows on "Confirm Photography" tasks: a Text button with an editable message to the deal's photographer.
// Nothing sends automatically; the agent opens the text, edits it if needed, and sends it from their phone.
const TEXT_BODY = 'Hi {{photographer_first_name}}, this is {{agent_first_name}}. I just wanted to follow up regarding my request for photography for {{address}}.';

const SCHEDULE_BODY = 'Hi {{photographer_first_name}}, this is {{agent_first_name}}. We have a listing at {{address}} and the requested photography date is {{photography_date}}. Could you let me know what date and time you can come out? Thank you!';

const fill = (text, data) => String(text || '').replace(/\{\{(\w+)\}\}/g, (m, k) => (data[k] == null ? '' : String(data[k])));

const btn = { display: 'inline-block', padding: '8px 14px', borderRadius: 6, fontWeight: 700, fontSize: 13, textDecoration: 'none', border: '1px solid #B8962E', background: '#B8962E', color: '#FFFFFF', cursor: 'pointer' };
const btnOff = { ...btn, background: '#FFFFFF', color: '#B8962E', borderColor: '#D5D9E0', opacity: 0.5, cursor: 'not-allowed' };

export default function PhotographerQuickText({ task, deal, ownerUid }) {
  const taskName = task.name || task.title || '';
  const [photographer, setPhotographer] = useState(null);
  const [agent, setAgent] = useState(null);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const isPhotoTask = /confirm photography|schedule photography/i.test(taskName);
  const isSchedule = /schedule photography/i.test(taskName);

  useEffect(() => {
    if (!isPhotoTask) return;
    get(ref(database, 'partners')).then((snap) => {
      const list = snap.exists() ? Object.values(snap.val()) : [];
      const name = deal?.photographer || '';
      const match = list.find((p) => p && p.partnerType === 'Photographer'
        && `${p.firstName || ''} ${p.lastName || ''}`.trim() === name);
      setPhotographer(match || null);
    }).catch((err) => console.error('Could not load photographers', err));
    if (ownerUid) {
      get(ref(database, `users/${ownerUid}/profile`))
        .then((snap) => {
          const profile = snap.exists() ? snap.val() : {};
          setAgent({ firstName: profile.firstName || '' });
        })
        .catch((err) => console.error('Could not load agent', err));
    }
  }, [isPhotoTask, deal?.photographer, ownerUid]);

  if (!isPhotoTask) return null;

  const digits = (photographer?.phone || '').replace(/[^0-9+]/g, '');
  const data = {
    address: deal?.propertyAddress || '',
    photographer_first_name: photographer?.firstName || (deal?.photographer || '').split(' ')[0] || '',
    agent_first_name: agent?.firstName || '',
    photography_date: deal?.photographyDate ? new Date(`${deal.photographyDate}T00:00:00`).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : 'the date on the request',
  };

  if (!deal?.photographer) {
    return <div style={{ margin: '6px 0', fontSize: 13, color: '#5B6270' }}>No photographer selected on this deal yet.</div>;
  }

  return (
    <div style={{ margin: '6px 0' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 13, color: '#1A1A1A' }}>Photographer: <strong>{deal.photographer}</strong>{photographer?.phone ? ` · ${photographer.phone}` : ''}</span>
        <button type="button" onClick={() => { setMessage(fill(isSchedule ? SCHEDULE_BODY : TEXT_BODY, data)); setOpen(!open); }} disabled={!digits} style={digits ? btn : btnOff}>Text Photographer</button>
        {!photographer && <span style={{ fontSize: 12, color: '#5B6270' }}>This photographer is not in Partners yet.</span>}
      </div>
      {open && digits && (
        <div style={{ marginTop: 8, padding: 10, border: '1px solid #D5D9E0', borderRadius: 8, background: '#FFFFFF' }}>
          <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={4} style={{ width: '100%', boxSizing: 'border-box', padding: 8, borderRadius: 6, border: '1px solid #D5D9E0', fontSize: 14, fontFamily: 'inherit', color: '#1A1A1A' }} />
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <a href={`sms:${digits}?body=${encodeURIComponent(message)}`} style={btn}>Send text</a>
            <button type="button" onClick={() => setOpen(false)} style={{ ...btn, background: '#FFFFFF', color: '#5B6270', borderColor: '#D5D9E0' }}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}
